module.exports = __webpack_public_path__ + "static/media/IMG_2607.d49f0431.JPG";